import currenciesBook from 'assets/images/currenciesBook.png';

import { FLIP_BOOK, GIFT_BOOK, FLIP_BOOKS } from '../const';

import { getFlipBookPurchases } from './utils';

const currencies = {
  book: {
    id: 'waehrungen',
    format: FLIP_BOOKS,
    title: 'How to invest (Currencies)',
    subtitle: '',
    videos: 'Erwin W. Heri, Patrick Eugster, Alexandra Janssen',
    layoutAndProduction: 'Hanspeter Frey',
    scope: { pages: 24, videos: 16 },
    price: [29, 35],
    introductions: ['The third instalment in our digital book series on the fundamentals of investing focuses on currencies'],
    image: currenciesBook,
    overviewImg: currenciesBook,
  },
  bookIds: [22, 23],
  getDefaultOption: ({ isPremium, isBasic }) => (isBasic && 1) || (!isPremium && 2) || 0,
  getDefaultStrictMode: ({ isPremium, isBasic }) => Boolean(isBasic || isPremium),
  orderOptions: [FLIP_BOOK, GIFT_BOOK],
  purchases: getFlipBookPurchases([29, 35], [22, 23]),
};

export default currencies;
